import { useId, useState } from "react";
import { useGuides } from "./guides-context";
import { text } from "./registry";
import { WELCOME_TOUR_ID } from "./tours";

/**
 * "Guides" in the account menu (English, as all menu chrome; ruling 2026-10-04): every tour available to this person with Replay, and the welcome
 * tour again. A tour that belongs to another page says which page to open first. Absent while Features__GuidedTours is off.
 */
export function GuidesMenu({ close }: { close: () => void }) {
  const guides = useGuides();
  const headingId = useId();
  const [message, setMessage] = useState<string | null>(null);
  if (!guides.enabled) return null;

  function start(tourId: string) {
    const why = guides.replay(tourId);
    if (why) setMessage(why);
    else close();
  }

  const hasWelcome = guides.available.some((tour) => tour.id === WELCOME_TOUR_ID);
  return (
    <section className="gf-guides stack" aria-labelledby={headingId}>
      <h2 className="gf-pop-title" id={headingId}>
        Guides
      </h2>
      {hasWelcome && (
        <button type="button" className="btn sec" onClick={() => start(WELCOME_TOUR_ID)}>
          Show the welcome tour again
        </button>
      )}
      {/* Each tour's own Thai title (the tours stay in Thai, ruling 2026-10-05): exempt from the English-only chrome checks;
          the heading and buttons around it are English and are still checked. */}
      <ul data-chrome-exempt="guides-list">
        {guides.available.map((tour) => (
          <li key={tour.id}>
            <span lang="th">
              {text(tour.title)}
              {tour.pageName && <span className="help">{text(tour.pageName)}</span>}
            </span>
            <button type="button" className="linkish" aria-label={`Replay: ${text(tour.title)}`} onClick={() => start(tour.id)}>
              Replay
            </button>
          </li>
        ))}
      </ul>
      {message && (
        <p className="help" role="status" lang="th" data-chrome-exempt="guides-list">
          {message}
        </p>
      )}
    </section>
  );
}
